/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StageAdvancementNotificationService } from '@gh/builder-shared';
import { SalesFolderRestService, SiteRestService } from '@gh/builder-shared-data';
import { getRouteParam, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { map$, tap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { rfqInspectionFromDto, RfqSite, rfqSiteFromDto, rfqSiteToDto } from './rfq.model';

@Injectable()
export class SiteDetailsBusinessService implements InitViewService {
  constructor(private siteRest: SiteRestService,
              private salesFolderRest: SalesFolderRestService,
              private stageAdvancementNotifications: StageAdvancementNotificationService) {

  }

  create(sfId: ID, site: any): Observable<RfqSite> {
    return this.siteRest.create(sfId, rfqSiteToDto(site)).pipe(
      map$(rfqSiteFromDto),
      tap$((created) => this.stageAdvancementNotifications.notifyAfterSiteCreated(sfId, created && created.id)));
  }

  initView(route: ActivatedRouteSnapshot): any {
    const salesFolderId = getRouteParam(route, 'salesFolderId');
    const siteId = getRouteParam(route, 'siteId');

    return {
      generalInfo: this.salesFolderRest.getRfqGeneral(salesFolderId),
      siteDetails: siteId
        ? this.siteRest.get(salesFolderId, siteId).pipe(map$(rfqSiteFromDto))
        : this.siteRest.init(salesFolderId).pipe(
          map$((inspections) => inspections.map(rfqInspectionFromDto)),
          map$((inspections) => ({ inspections, isInspected: false }))),
    };
  }

  update(sfId: ID, site: RfqSite): Observable<RfqSite> {
    return this.siteRest.update(sfId, rfqSiteToDto(site)).pipe(map$(rfqSiteFromDto));
  }

  save(sfId: ID, site: RfqSite): Observable<RfqSite> {
    return site.id ? this.update(sfId, site) : this.create(sfId, site);
  }
}
